// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2e-eC","vLegacy":"SelectSecondary_vLegacy__2_9zO","error":"SelectSecondary_error__3IEbC","disabled":"SelectSecondary_disabled__1vPqa"};